// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"87eda128","373":"5ae49788","648":"df94fce3","814":"671805f9"}[chunkId] + ".chunk.css";
};